import React from 'react';
import { Badge, ConfigProvider } from 'antd';
import { COLORS } from '@guuru/theme-common';

interface ScoreProps {
  score: number;
  height?: number;
  fontSize?: number;
}

const Score = function ({ score, height = 32, fontSize = 13 }: ScoreProps) {
  return (
    <ConfigProvider
      theme={{
        components: {
          Badge: {
            indicatorHeight: height,
            textFontSize: fontSize,
          },
        },
      }}
    >
      <Badge
        overflowCount={1000}
        count={score}
        color={COLORS.blue}
      />
    </ConfigProvider>
  );
};

export default Score;
